import FilterModal from "src/components/common/FilterFrame/FilterModal";
import type { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";
import { myOptions } from "src/components/users/UserForm";

export const fields: FilterFieldConfig[] = [
    { key: "proposalNumber", label: "Proposal Number", type: "text", default: "" },
    { key: "proposalDate", label: "Proposal Date", type: "range", default: "", inputType: "date" },
    { key: "requesterId", label: "Requester", type: "asyncSelect", default: "", fileName: "common/searchUser.php", placeholder: "Search user…" },
    { key: "projectId", label: "Project", type: "asyncSelect", default: "", fileName: "common/searchProject.php", placeholder: "Search project…" },
    { key: "approverId", label: "Approver", type: "asyncSelect", default: "", fileName: "common/searchUser.php", placeholder: "Search user…" },
    {
        key: "department",
        label: "Department",
        type: "select",
        default: "",
        options: [
            { value: "", label: "Select" },
            ...Object.entries(myOptions.department).flatMap(([group, values]) =>
                (values as string[]).map(value => ({ value, label: `${group} - ${value}` }))
            ),
        ],
    },
    { key: "status", label: "Status", type: "select", default: "", options: [{ value: "", label: "Select" }, { value: "Submitted", label: "Submitted" }, { value: "Re-Submitted", label: "Re-Submitted" }, { value: "Approved", label: "Approved" }, { value: "Rejected", label: "Rejected" }] },
    { key: "void", label: "Validity", type: "select", default: "no", options: [{ value: "no", label: "Valid" }, { value: "yes", label: "Void" }, { value: "all", label: "All" }] },
    { key: "total", label: "Total", type: "range", default: "", inputType: "number" },
    { key: "notes", label: "Notes", type: "text", default: "" },
    { key: "creatorId", label: "Creator", type: "asyncSelect", default: "", fileName: "common/searchUser.php", placeholder: "Search user…" },
    { key: "updaterId", label: "Updated By", type: "asyncSelect", default: "", fileName: "common/searchUser.php", placeholder: "Search user…" },
];

export default function ProposalFilterForm() {
    return <FilterModal title = "Filter" width = {650} fields = {fields} />;
}
